<template>
    <div class="col-12 col-md-10 col-lg-8 pin-reminder-wrapper py-3">
        <h4 class="font-weight-bold text-center mb-4 text-primary">{{ $t('forgot_my_password') }}</h4>
        <p class="text-muted text-center mb-4 small">
            {{ $t('pin_reminder_info_text') }}
        </p>

        <ValidationObserver ref="reminderForm">
            <div class="row">
                <div class="col-12 mb-3">
                    <b-form-group>
                        <b-form-radio-group
                            v-model="identityType"
                            :options="[
                                { text: $t('tc_no'), value: 'tc' },
                                { text: $t('passport_number'), value: 'passport' }
                            ]"
                            buttons
                            button-variant="outline-primary"
                            size="sm"
                            class="w-100 d-flex custom-radio-group"
                        ></b-form-radio-group>
                    </b-form-group>
                </div>

                <div class="col-12 mt-1">
                    <ValidationProvider
                        :name="identityType === 'tc' ? 'nationalId' : 'passportNumber'"
                        :rules="identityType === 'tc' ? 'required|digits:11' : 'required'"
                        v-slot="{valid, errors}"
                    >
                        <b-form-group :label="identityType === 'tc' ? $t('tc_no') : $t('passport_number')" class="position-relative">

                            <b-form-input
                                type="text"
                                :state="errors[0] ? false : (valid ? true : null)"
                                v-mask="identityType === 'tc' ? '###########' : ''"
                                v-model="form.identity"
                            ></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>

                <div class="col-12 mt-2">
                    <ValidationProvider name="birthdate" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('birthdate')" class="position-relative">
                            <SelectDate   v-model="form.birthdate" :state="errors[0] ? false : (valid ? true : null)" :validation-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </div>

                <div class="col-12 mt-4">
                    <b-button @click="sendReminder" block variant="primary" :disabled="loading" class="font-weight-bold py-2">
                        <b-spinner small v-if="loading" class="mr-2"></b-spinner>
                        {{ $t('send') }}
                    </b-button>
                </div>

                <div class="col-12 mt-3 text-center">
                    <b-button @click="$emit('switch-to-login')" variant="link" class="text-dark font-weight-bold">
                        <i class="ri-arrow-left-line mr-1"></i> {{ $t('back_to_login') }}
                    </b-button>
                </div>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import SpecialStudentApplicationRegisterServices from "@/services/SpecialStudentApplicationRegisterServices";

export default {
    name: "PinReminderComponent",
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            identityType: 'tc',
            form: {
                identity: null,
                birthdate: null
            },
            loading: false
        }
    },
    methods: {
        async sendReminder() {
            const isValid = await this.$refs.reminderForm.validate();
            if (!isValid) return;

            this.loading = true;
            const payload = {
                national_id: this.identityType === 'tc' ? this.form.identity : null,
                passport_number: this.identityType === 'passport' ? this.form.identity : null,
                birthdate: this.form.birthdate
            };
            try {
                const response = await SpecialStudentApplicationRegisterServices.pinReminder(payload);
                this.$toast.success(this.$t("api." + response.data.message));
                setTimeout(() => {
                    this.$emit('switch-to-login');
                }, 500);
            } catch (error) {
                this.showErrors(error, this.$refs.reminderForm);
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>

<style scoped>
.custom-radio-group >>> .btn {
    flex: 1;
}

.pin-reminder-wrapper {
    animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}
</style>
